"use client";

import { useEffect } from "react";

import { sendContestPageView } from "../api";

/** Where a visit is remembered: one count per contest per browser visit. */
export const PAGE_VIEW_KEY_PREFIX = "progsity.contest-view.";

/**
 * `EX-SPN01`, `docs/29` §6.23: one open of the contest page for the sponsor
 * sheet, sent once per browser visit (the tab's `sessionStorage`), so a
 * contestant who reloads through a round counts once. The server counts only
 * a contest whose stamp carries the sponsors and answers 204 either way. With
 * storage blocked it sends on every mount, which is the honest fallback.
 */
export function useContestPageView(slug: string): void {
  useEffect(() => {
    const key = `${PAGE_VIEW_KEY_PREFIX}${slug}`;
    try {
      if (window.sessionStorage.getItem(key)) return;
      window.sessionStorage.setItem(key, "1");
    } catch {
      /* storage blocked: count this open */
    }
    void sendContestPageView(slug);
  }, [slug]);
}
